import { animate, style, transition, trigger } from '@angular/animations';

export const fader = trigger('routeAnimations', [
  transition('void => *', [
    style({ opacity: 0 }),
    animate(2000, style({ opacity: 1 })),
  ]),
]);


export const fadeAnimation = trigger('fadeAnimation', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('350ms ease-in', style({ opacity: 1 }))
  ]),
  transition(':leave', [
    animate('350ms ease-out', style({ opacity: 0 }))
  ])
])